<template>
	<div class="wp100">
		<div class="disf jc-s ai-c pl10 mb5" style="height: 32px">
			<p><i class="fs16 sz sztougao mr5" style="color: #909399"></i>征文投稿</p>
			<div>
				<el-button style="background-color: #B89DC1; color: #ffffff" class="fs14 rad25" size="small"
					icon="el-icon-circle-plus" @click="submitForm">提交征文
				</el-button>
			</div>
		</div>

		<div class="wp100 oh pb10" style="height: calc(100vh - 125px)">
			<div style="
          width: calc(100% + 13px);
          overflow-y: auto;
          padding-right: 0px;
          height: calc(100vh - 125px);
        ">
				<div class="wp100">
					<div class="bg-c-fff p20 rad5 shadow-common wp100">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid #B89DC1">
							主题
						</div>
						<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

						<div class="dis-f h40 lh40 wp40">
							<div class="col-gray w130 fs14">
								征文主题<span style="color: red" class="pl5 h40 lh40">*</span>
							</div>
							<div style="width: calc(100% - 130px)">
								<el-select style="width: 100%" v-model="solicit.Info.subject_id" clearable
									placeholder="请选择">
									<el-option v-for="item in subjectList" :key="item.id" :label="item.title"
										:value="item.id">
									</el-option>
								</el-select>
							</div>
						</div>

						<div class="dis-f h40 lh40 wp100">
							<div class="wp40 h40 lh40 disf">
								<div class="fs14 w130 col-gray">投稿类型</div>
								<div class="fs14">{{ solicit.Info.solicit_type.title }}</div>
							</div>
						</div>

						<div class="dis-f h40 lh40 wp100" v-if="foreignAid.region != ''">
							<div class="wp40 h40 lh40 disf">
								<div class="fs14 w130 col-gray">区域</div>
								<div class="fs14">{{ foreignAid.region }}</div>
							</div>
							<div class="wp40 h40 lh40 disf pl40">
								<div class="fs14 w130 col-gray">征文数</div>
								<div class="fs14">
									{{ foreignAid.solicited_total }}/{{
                    foreignAid.solicit_set_total
                  }}篇
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 征文信息 -->
				<div class="wp100 mt10">
					<div class="p20 bg-c-fff rad5 shadow-common wp100">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid #B89DC1">
							征文信息
						</div>
						<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

						<div class="h40 wp40 disf">
							<div class="w130 h40 lh40 fs14 col-gray">
								文章名<span style="color: red" class="pl5 h40 lh40">*</span>
							</div>
							<div style="width: calc(100% - 130px)" class="h40 lh40">
								<p class="fs14" v-if="solicit.Info.article_title != ''">
									{{ solicit.Info.article_title }}
								</p>
								<p class="fs14 col-gray" v-else>上传后自动获取</p>
							</div>
						</div>

						<div class="h40 wp40 disf mb10">
							<div class="w130 h40 lh40 fs14 col-gray">副标题</div>
							<div style="height: 20px;width: 30px;box-sizing: border-box;border-bottom: 1px solid;margin-right: 10px;"></div>
							<el-input style="width: calc(100% - 130px)" placeholder="请输入副标题(如有)"
								v-model="solicit.Info.article_subtitle" clearable>
							</el-input>
						</div>
					</div>
				</div>

				<!-- 上传 -->
				<div class="wp100 mt10">
					<div class="p20 bg-c-fff rad5 shadow-common">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid #B89DC1">
							稿件上传
						</div>
						<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>

						<el-upload class="upload-demo mt10" ref="upload" action="" accept=".doc,.docx,.pdf"
							:before-remove="beforeRemove" :auto-upload="false" :limit="1" :on-exceed="handleExceed"
							:file-list="fileList" :on-change="getFile">
							<el-button size="small" type="default" class="fs14 rad25"><i class="el-icon-upload pr5"></i>点击上传
							</el-button>
							<div slot="tip" class="el-upload__tip">
								附件支持DOC、DOCX格式 系统自动将附件名填为文章名
							</div>
						</el-upload>
					</div>
				</div>

				<!-- 作者信息 -->
				<div class="wp100 mt10">
					<div class="wp100 p20 bg-c-fff rad5 shadow-common">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid #B89DC1">
							作者信息
						</div>
						<div class="wp100 mt10 mb10" style="background-color: #e4e7ed; height: 1px"></div>


						<!-- 作者姓名和手机号 -->
						<div class="h40 lh40 wp100 disf mb10">
							<div class="wp40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">
									第一作者姓名<span style="color: red" class="pl5 h40 lh40">*</span>
								</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入姓名"
									v-model="solicit.AuthorList[0].author" clearable @input="changeContact">
								</el-input>
							</div>
						</div>



						<div class="h40 lh40 wp100 disf mb10">
							<div class="wp40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">
									单位<span style="color: red" class="pl5 h40 lh40">*</span>
								</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入单位"
									v-model="solicit.AuthorList[0].author_unit_1" clearable>
								</el-input>
							</div>
							<div class="wp40 disf ml40">
								<div class="w130 h40 lh40 fs14 col-gray">
									手机号<span style="color: red" class="pl5 h40 lh40">*</span>
								</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入联系人手机号"
									v-model="solicit.Info.contact_info.contact_phone.phone" clearable>
								</el-input>
							</div>
						</div>

						<div class="h40 lh40 wp100 disf mb10">
							<div class="wp40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">
									邮箱<span style="color: red" class="pl5 h40 lh40">*</span>
								</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入联系人邮箱"
									v-model="solicit.Info.contact_info.contact_email" clearable>
								</el-input>
							</div>
							<div class="wp40 ml40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">省市区<span style="color: red" class="pl5 h40 lh40">*</span></div>
								<div class="disf jc-s" style="width: calc(100% - 130px);">
									<el-select v-model="solicit.Info.contact_info.contact_province.provinceId"
										placeholder="请选择省" class="wp30" @change="provinceChange">
										<el-option :label="province.provinceName" :value="province.provinceId"
											v-for="province in provinceList">
										</el-option>
									</el-select>
									<el-select v-model="solicit.Info.contact_info.contact_city.cityId"
										placeholder="请选择市" class="wp30" @change="cityChange">
										<el-option :label="city.cityName" :value="city.cityId" v-for="city in cityList">
										</el-option>
									</el-select>
									<el-select v-model="solicit.Info.contact_info.contact_area.areaId"
										placeholder="请选择区" class="wp30" @change="areasChange">
										<el-option :label="arears.areaName" :value="arears.areaId"
											v-for="arears in arearsList"></el-option>
									</el-select>
								</div>
							</div>
						</div>
						
						<div class="h40 lh40 wp100 disf mb20">
							<div class="wp40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">详细地址<span style="color: red" class="pl5 h40 lh40">*</span></div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入详细地址"
									v-model="solicit.Info.contact_info.contact_address" clearable>
								</el-input>
							</div>
						</div>


						<div class="h40 lh40 wp100 disf mb10">
							<div class="wp40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">第二作者姓名</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入姓名"
									v-model="solicit.AuthorList[1].author" clearable>
								</el-input>
							</div>
							<div class="wp40 ml40 disf">
								<div class="w130 h40 lh40 fs14 col-gray">单位</div>
								<el-input style="width: calc(100% - 130px)" placeholder="请输入单位"
									v-model="solicit.AuthorList[1].author_unit_1" clearable>
								</el-input>
							</div>
						</div>

					</div>
				</div>

				<my-dialog title="选择联系人" path="essay/contact.vue" ref="chooseContact" width="700px" height="700px"
					@ok="afterChoose"></my-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import * as tokenUtil from "../../utils/token";
	import * as dataConfig from "../../data/config";
	export default {
		methods: {},
		data() {
			return {
				provinceList: [],
				cityList: [],
				arearsList: [],
				solicit: {
					Info: {
						subject_id: undefined,
						subject_title: "",
						solicit_type: {
							SType: 0,
							title: "自由投稿",
						},
						article_title: "",
						article_subtitle: "",
						major_author_id: 0,
						contact_info: {
							contact_name: "",
							contact_phone: {
								phone: "",
							},
							contact_email: "",
							contact_province: {
								provinceId: undefined,
								provinceName: "",
							},
							contact_city: {
								cityId: undefined,
								cityName: "",
							},
							contact_area: {
								areaId: undefined,
								areaName: "",
							},
							contact_address: "",
							contact_postcode: "",
						},
						aid_region: "",
					},
					AuthorList: [{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
						{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
					],
					DocFileName: "",
					DocFile: "",
				},
				fileList: [],
				myInfo: {},
				subjectList: [],
				foreignAid: {
					region: "",
					solicited_total: 0,
					solicit_set_total: 0,
				},
			};
		},

		mounted() {
			this.$api.addr
				.getAddrInfo(this.solicit.Info.contact_info.contact_province.provinceId || 0, this.solicit.Info.contact_info
					.contact_city.cityId || 0)
				.then((res) => {
					this.provinceList = res.Item1;
					this.cityList = res.Item2;
					this.arearsList = res.Item3;
					this.init();
				})
		},

		methods: {
			init(id) {
				id = id || 0;
				if (id > 0) {
					//征文主题列表
					this.$api.essay
						.edit(id)
						.then((res) => {
							let aidType =
								res.Data.foreignAid != null ?
								res.Data.foreignAid.aid_type || 0 :
								0;
							aidType = aidType == 4 ? 0 : aidType;
							this.subjectList = res.Data.subjectList;
							if (res.Data.subjectList.length > 0) {
								this.solicit.Info.subject_id = res.Data.subjectList[0].id;
								this.solicit.Info.subject_title = res.Data.subjectList[0].title;
							}

							if (res.Data.detail !== null) {
								this.solicit.Info = res.Data.detail.Info;
								if (res.Data.detail.AuthorList.length > 1) {
									this.solicit.AuthorList = res.Data.detail.AuthorList;
								} else {
									this.solicit.AuthorList[0] = res.Data.detail.AuthorList[0];
								}
							} else {
								this.solicit.Info.solicit_type.SType = aidType;
								this.solicit.Info.solicit_type.title =
									dataConfig.solicitType.find((x) => x.id == aidType).title;
							}
							if (res.Data.foreignAid) {
								this.foreignAid = res.Data.foreignAid;
								this.solicit.Info.aid_region = res.Data.foreignAid.region;
							}

						})
						.catch((err) => {
							this.alertError(err.Data);
						});
				} else {
					this.$api.essay
						.index()
						.then((res) => {
							let aidType =
								res.Data.foreignAid != null ?
								res.Data.foreignAid.aid_type || 0 :
								0;
							aidType = aidType == 4 ? 0 : aidType;
							this.subjectList = res.Data.subjectList;
							if (res.Data.subjectList.length > 0) {
								this.solicit.Info.subject_id = res.Data.subjectList[0].id;
								this.solicit.Info.subject_title = res.Data.subjectList[0].title;
							}

							this.solicit.Info.solicit_type.SType = aidType;
							this.solicit.Info.solicit_type.title = dataConfig.solicitType.find(
								(x) => x.id == aidType
							).title;

							if (res.Data.foreignAid) {
								this.foreignAid = res.Data.foreignAid;
								this.solicit.Info.aid_region = res.Data.foreignAid.region;
							}

							// this.solicit.Info.contact_info = res.Data.contact;
						})
						.catch((err) => {
							console.log("err", err);
							//this.alertError(err.Data);
						});
				}
				this.myInfo = tokenUtil.getInfo().info;
			},

			changeContact(e) {
				this.solicit.Info.contact_info.contact_name = e;
			},


			// 删除上传的文件
			beforeRemove(file, fileList) {
				this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.essay.DocFileName = "";
					this.essay.DocFile = "";
					this.essay.Info.article_title = "";
					this.fileList = [];
					return true;
				});
				return false;
			},

			// 选择的文件超出限制范围
			handleExceed(files, fileList) {
				this.$message.warning(`超出文章选择上限`);
			},

			// 上传文件获取文件信息和base64加密
			getFile(file, fileList) {
				this.solicit.DocFileName = file.raw.name;
				this.solicit.Info.article_title = file.raw.name.substring(
					0,
					file.raw.name.lastIndexOf(".")
				);
				var extension = file.raw.name
					.substring(file.raw.name.lastIndexOf("."))
					.toLocaleLowerCase();
				let allowExts = [".doc", ".docx"];

				// 判断文件大小是否小于20k
				let fileSize = file.size / 1024 / 1024 < 0.01;
				if (!allowExts.includes(extension)) {
					this.$message.warning("请上传word格式文件");
					this.fileList = [];
					return;
				}
				if (fileSize) {
					this.$message.warning("上传文档过小");
					this.fileList = [];
					return;
				}
				this.getBase64(file.raw).then((res) => {
					// 这里是Base64结果
					this.solicit.DocFile = res.split(",")[1];
				});
			},

			getBase64(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					let imgResult = "";
					reader.readAsDataURL(file);
					reader.onload = function() {
						imgResult = reader.result;
					};
					reader.onerror = function(error) {
						reject(error);
					};
					reader.onloadend = function() {
						resolve(imgResult);
					};
				});
			},


			// 省市区切换事件和方法
			// 获取市列表数据
			getCitys(pId) {
				this.$api.addr
					.getCitys(pId)
					.then((res) => {
						this.cityList = res;
					})
					.catch((res) => {});
			},

			// 获取区列表数据
			getAreas(cId) {
				this.$api.addr
					.getAreas(cId)
					.then((res) => {
						this.arearsList = res;
					})
					.catch((res) => {});
			},

			// 省下拉框变化
			provinceChange(val) {
				this.solicit.Info.contact_info.contact_city.cityId = undefined;
				this.solicit.Info.contact_info.contact_area.areaId = undefined;
				this.solicit.Info.contact_info.contact_province.provinceId = val;
				this.solicit.Info.contact_info.contact_province.provinceName = this.provinceList.find(x => x.provinceId ==
					val).provinceName;
				this.getCitys(val);
			},

			// 市数据变化
			cityChange(val) {
				this.solicit.Info.contact_info.contact_area.areaId = undefined;
				this.solicit.Info.contact_info.contact_city.cityId = val;
				this.solicit.Info.contact_info.contact_city.cityName = this.cityList.find(x => x.cityId == val).cityName;
				this.getAreas(val);
			},

			// 区选择数据发生变化
			areasChange(val) {
				this.solicit.Info.contact_info.contact_area.areaId = val;
				this.solicit.Info.contact_info.contact_area.areaName = this.arearsList.find(x => x.areaId == val).areaName;
			},


			//保存提交
			submitForm() {
				if (this.solicit.DocFileName == "") {
					this.alertError("请上传投稿文件");
					return;
				} else if (this.solicit.AuthorList[0].author == "") {
					this.alertError("请填写第一作者姓名");
					return;
				} else if (this.solicit.AuthorList[0].author_unit_1 == "") {
					this.alertError("请填写第一作者单位");
					return;
				} else if (this.solicit.Info.contact_info.contact_name.trim() == "") {
					this.alertError("请填写联系人");
					return;
				}else if(this.solicit.Info.contact_info.contact_phone.phone == ""){
					this.alertError("请填写联系手机号");
					return;
				}else if(this.solicit.Info.contact_info.contact_email == ""){
					this.alertError("请填写联系邮箱");
					return;
				}else if(this.solicit.Info.contact_info.contact_province.provinceName == "" || this.solicit.Info.contact_info.contact_city.cityName == "" || this.solicit.Info.contact_info.contact_area.areaName == ""){
					this.alertError("请选择省市区");
					return;
				}else if(this.solicit.Info.contact_info.contact_address == ""){
					this.alertError("请填写详细地址");
					return;
				}

				delete this.solicit.ForeignAid;
				this.$api.essay
					.solicitSubmit(this.solicit)
					.then((res) => {
						if (res.Status == 1) {
							this.alertSuccess("提交成功");
							//直接跳转
							this.$router.push("/essay");
						} else {
							this.alertError(`${res.Data.Warn},请检查后再提交`);
						}
					})
					.catch((err) => {
						this.alertError(err.Data);
					});
			},

			// 打开编辑、添加联系人的弹层
			openContact() {
				this.$refs.chooseContact.show();
			},

			// 选择了会员联系方式的回调数据
			afterChoose(chooseContact) {
				console.log("上海教育科研");
				this.solicit.Info.contact_info.contact_name = chooseContact.name;
				this.solicit.Info.contact_info.contact_phone.phone = chooseContact.phone;
				this.solicit.Info.contact_info.contact_email = chooseContact.email;
				this.solicit.Info.contact_info.contact_province.provinceId =
					chooseContact.province_id;
				this.solicit.Info.contact_info.contact_province.provinceName =
					chooseContact.province_name;
				this.solicit.Info.contact_info.contact_city.cityId =
					chooseContact.city_id;
				this.solicit.Info.contact_info.contact_city.cityName =
					chooseContact.city_name;
				this.solicit.Info.contact_info.contact_area.areaId =
					chooseContact.areas_id;
				this.solicit.Info.contact_info.contact_area.areaName =
					chooseContact.areas_name;
				this.solicit.Info.contact_info.contact_address = chooseContact.address;
				this.solicit.Info.contact_info.contact_postcode = chooseContact.postcode;
			},

			// 关闭抽屉
			// reSearch是不是要重新更新数据
			closeDrawer(reSearch) {
				this.$emit("editCallback", reSearch);
				this.$emit("hide");
			},
		},
	};
</script>

<style lang="scss" scoped>
	.body {
		padding: 20px 200px;
	}

	.btns {
		padding: 40rpx;
		background: #5084f3;
		background-color: #5084f3;
		color: #fff;
		box-shadow: 0 1px 10rpx 1rpx rgba(0, 0, 0, 0.1);
	}

	.el-tab-pane {
		padding-top: 10px;
	}

	.body-l {
		width: 40%;
		border: 1px solid #efefef;
		// padding: 10px;
		margin: 40px;
	}

	.body-r {
		width: 40%;
		border: 1px solid #efefef;
		margin: 40px;
	}

	.el-input {
		width: 40%;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: 480px;
	}

	.pannel-title {
		height: 20px;
		line-height: 20px;
		padding-left: 10px;
		font-weight: bold;
	}

	.storeEdit-title-line {
		width: 5px;
		height: 20px;
		background-color: #f93e61;
		margin-right: 10px;
	}
</style>
